import React from "react";
import ByondGrid2 from './../../customGrid/CustomGrid';
import CustomGridHeader from './../../customGrid/CustomGridHeader';
import Page from './../../component/Page/Page';
import DashboardGrid from './DashboardGrid';
import DashboardTotalAsset from './../../component/Asset/DashboardTotalAsset';
import DashboardTotalTransaction from './../../transaction/component/DashboardTotalTransaction';
import {Col, Row} from 'react-bootstrap';
import {PropTypes} from 'prop-types';

class NewDashboardPage extends React.Component {

  metadata = new DashboardGrid();

  constructor(props) {
    super(props);
    this.state = {customFilter: {}};
    this.getGridMetadata = this.getGridMetadata.bind(this);
  }

  componentWillMount() {
    this.getGridMetadata(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params !== this.props.match.params) {
      this.getGridMetadata(nextProps);
    }
  }

  getGridMetadata(props) {
    const {match} = props;
    const metadata = this.metadata;//GridEntityService.getEntity(match.params.entity);
    this.setState({metadata: metadata});
  }

  onChange(newCustomFilter) {
    this.setState({customFilter: JSON.parse(JSON.stringify(newCustomFilter))});
  }

  render() {
    const {match, history} = this.props;
    const {metadata, customFilter} = this.state;
    const endpoint = metadata.endpoint;//GridEndpointService.getUrl(metadata.endpoint, this.props, this.state);

    const headerCustom = <CustomGridHeader endpoint={endpoint} match={match} history={history} metadata={metadata}/>;
    const customHeader = metadata.customHeader ? metadata.customHeader(this.props, this.state, (value) => this.onChange(value)) : '';

    return (

        <Page title="Dashboard" {...this.props}>
          <Row>
            <DashboardTotalAsset/>
            <DashboardTotalTransaction/>
          </Row>
          <Row>
            <hr/>
            <Col md={12} className="transactionList">
              <ByondGrid2 endpoint={endpoint} match={match} {...this.props} customFilter={customFilter} metadata={this.state.metadata}/>
            </Col>
          </Row>
        </Page>
    );

  }
}

NewDashboardPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default NewDashboardPage;



// WEBPACK FOOTER //
// ./src/pages/Dashborad/NewDashboardPage.js